/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultFooter from "examples/Footers/DefaultFooter";

// About Us page sections
import Information from "pages/LandingPages/AboutUs/sections/Information";
import Team from "pages/LandingPages/AboutUs/sections/Team";
import Newsletter from "pages/LandingPages/AboutUs/sections/Newsletter";

// Routes
import footerRoutes from "footer.routes";
import {useMediaQuery, useTheme} from '@mui/material';

// Images
import videoBg from "assets/video/background-video.mp4";
import logo from 'assets/images/main_logo.svg';
import Grid2 from "@mui/material/Grid2";

function AboutUs() {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
        <MKBox
            position="absolute"
            top={isSmallScreen ? '0.5rem' : '1rem'} // 작은 화면에서는 top 값을 줄임
            left={isSmallScreen ? '0.5rem' : '1rem'} // 작은 화면에서는 left 값을 줄임
            zIndex={10}
            sx={{
                width: isSmallScreen ? '80px' : '120px', // 작은 화면에서는 로고 크기를 줄임
            }}
        >
            <img src={logo} alt="회사 로고" style={{ width: '100%', height: 'auto'}} />
        </MKBox>
        <MKBox
            minHeight="75vh"
            width="100%"
            sx={{
                position: "relative", // 상대 위치 설정
                overflow: "hidden", // 동영상 영역 초과 시 숨김
                display: "grid",
                placeItems: "center",
            }}
        >
            <video
                autoPlay
                loop
                muted
                style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover", // 동영상 비율 유지 및 채우기
                    zIndex: -1, // 다른 요소 뒤에 배치
                }}
            >
                <source src={videoBg} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        <Container>
          <Grid2
            container
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >

            <MKTypography variant="body1" color="white" opacity={0.8} mt={1} mb={3}>
              Join us for your business success
            </MKTypography>
              <MKTypography
                  variant="h1"
                  color="white"
                  sx={({ breakpoints, typography: { size } }) => ({
                      [breakpoints.down("md")]: {
                          fontSize: size["3xl"],
                      },
                  })}
              >
                  고객의 비즈니스 성공을 함께 합니다.
              </MKTypography>
            <MKTypography variant="h5" color="white" mt={8} mb={1} fontWeight="regular">
              LEAP PLACE .ICT
            </MKTypography>
            <MKBox display="flex" justifyContent="center" alignItems="center">
              <MKTypography component="a" variant="body1" color="white" href="#" mr={3}>
                <i className="fab fa-facebook" />
              </MKTypography>
              <MKTypography component="a" variant="body1" color="white" href="#" mr={3}>
                <i className="fab fa-instagram" />
              </MKTypography>
              <MKTypography component="a" variant="body1" color="white" href="#" mr={3}>
                <i className="fab fa-twitter" />
              </MKTypography>
              <MKTypography component="a" variant="body1" color="white" href="#">
                <i className="fab fa-google-plus" />
              </MKTypography>
            </MKBox>
          </Grid2>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Information />
        <Team />
        <Newsletter />
      </Card>
      <MKBox pt={1} px={1} mt={1}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default AboutUs;
